import React, { Component } from 'react'

import SelectClass from './SelectClass';

export default class Search extends Component {


	constructor() {
		super();
		this.state = {
			formData: {
				professor: '',
				subject: ''
			},
			classOptions: [
				{
					id: 'GSSRM',
					name: 'GSŠRM gimnazija',
					years: 4
				}
			],
			classData: {
				school: null,
				year: 0
			},
			showSelectClass: false
		}
	}










	componentDidMount() {
		const professor = this.props.professor ? this.props.professor : '';
		const subject = this.props.subject ? this.props.subject : '';
		this.setState(state => ({
			formData: {
				professor: professor,
				subject: subject
			}
		}));



		const school = localStorage.getItem('school'); //school.name
		const year = localStorage.getItem('year');

		if (school && year) {
			this.setState({
				classData: {
					school: this.state.classOptions.find((school1) => school1.name === school),
					year
				}
			})
			this.props.onSearch({ school: this.state.classOptions.find((school1) => school1.name === school).name, classYear: year });
		}
	}

	componentDidUpdate() {
		if (!this.state.formData.professor && this.props.professors && this.props.professors[0]) {
			const professor = this.props.professor ? this.props.professor : this.props.professors[0].name;
			const subject = this.props.subject ? this.props.subject : this.props.professors[0].subjects[0];
			this.setState(state => ({
				formData: {
					professor: professor,
					subject: subject
				}
			}));
		}
	}


	handleChange = (e) => {
		if (e.target.value && e.target.value !== '-') {
			if (e.target.name === 'professor') {
				this.setState({
					formData: {
						professor: e.target.value,
						subject: this.props.professors.find(prof => prof.name === e.target.value).subjects[0]
					}
				})
			} else {
				const value = e.target.value;
				this.setState(state => ({
					formData: {
						...state.formData,
						subject: value
					}
				}));
			}
		}
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.onSearch({ ...this.state.formData, school: this.state.classData.school.name, classYear: this.state.classData.year });
	}





	handleSelectClass = (school, year) => {
		if (school) {
			this.setState({
				classData: {
					school,
					year
				}
			})

			localStorage.setItem('school', school.name);
			localStorage.setItem('year', year);

			this.props.onSearch({ school: school.name, classYear: year });
		}
		this.setState({ showSelectClass: false });
	}

	showSelectClass = () => {
		this.setState({ showSelectClass: true });
	}



	render() {
		const { professor, subject } = this.state.formData;
		const { school, year } = this.state.classData;

		const profSubj = this.props.professors.find(prof => prof.name === professor);


		return (
			<div>

				{(school && year) &&
					<div className="card mb-1 btn schoolSelection-card" onClick={this.showSelectClass} >
						<div className="card-body text-center">
							{`${school.name} - ${year}. letnik `}{`	`} <i className="fas fa-cog"></i>
						</div>
					</div>
				}



				<div className="card card-colored shadow mb-2 search" >
					<form className="card-body mb-0" onSubmit={this.handleSubmit}>
						<div className="form-group">

							<div className="form-group">
								<label htmlFor="professor">Profesor </label>
								<select className="form-control" name="professor" onChange={this.handleChange} value={professor}>
									{this.props.professors.map(prof => (
										<option key={prof.name} >
											{prof.name}
										</option>
									))}
								</select>
							</div>

							<label htmlFor="professor">Predmet </label>
							<select className="form-control" name="subject" onChange={this.handleChange} value={subject}>
								{professor && profSubj ? (
									profSubj.subjects.map(subject => (
										<option key={subject} >
											{subject}
										</option>
									))
								) : (
										<option>
											-
									</option>
									)}

							</select>
						</div>

						<input className="btn btn-outline-primary btn-block" type="submit" value="Išči"></input>
					</form>



					{((!school || !year) || this.state.showSelectClass) && <SelectClass selected="4a" onSelect={this.handleSelectClass} options={this.state.classOptions} />}


				</div>
			</div>
		)
	}
}
